(() => {
  const configNode = document.getElementById('cfd-protection-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const base = window.Shopify?.routes?.root || '/';
  let busy = false;
  let failed = false;
  let pending = false;
  let current = { items: config.items };
  const isProtection = item => Number(item.variant_id || item.id) === config.variantId;
  const isSample = item => /sample|swatch/i.test((item.variant_title || '') + ' ' + (item.product_title || ''));
  const eligible = cart => {
    const products = cart.items.filter(item => !isProtection(item));
    return products.length > 0 && products.every(isSample);
  };
  const protectionUpdates = cart => {
    const updates = {};
    let retained = false;
    const allowed = eligible(cart);
    cart.items.filter(isProtection).forEach(item => {
      const quantity = allowed && !retained ? 1 : 0;
      retained = retained || quantity === 1;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    return updates;
  };
  const sectionIds = () => [
    document.getElementById('main-cart-items')?.dataset.id,
    document.getElementById('main-cart-footer')?.dataset.id,
    'cart-icon-bubble'
  ].filter(Boolean);
  async function request(path, body) {
    const response = await fetch(base + path, body ? {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: sectionIds(), sections_url: window.location.pathname })
    } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(config.error);
    return result;
  }
  function status(message) {
    document.querySelectorAll('[data-cfd-protection-status]').forEach(node => { node.textContent = message; });
    if (failed) {
      const errors = document.getElementById('cart-errors');
      if (errors) errors.textContent = message;
    }
  }
  function paint(cart) {
    current = cart;
    const selected = cart.items.some(isProtection);
    document.querySelectorAll('[data-cfd-protection]').forEach(card => {
      card.hidden = !eligible(cart);
      const button = card.querySelector('[data-cfd-protection-toggle]');
      button.setAttribute('aria-pressed', String(selected));
      button.disabled = busy;
      button.textContent = busy ? config.working : selected ? config.remove : config.add;
    });
    document.documentElement.classList.toggle('cfd-protection-busy', busy);
    document.documentElement.classList.toggle('cfd-protection-error', failed);
  }
  async function render(cart, sections) {
    const replacements = [
      ['main-cart-items', document.getElementById('main-cart-items')?.dataset.id, '.js-contents'],
      ['main-cart-footer', document.getElementById('main-cart-footer')?.dataset.id, '.cart__blocks'],
      ['cart-icon-bubble', 'cart-icon-bubble', null]
    ];
    let page;
    if (replacements.some(([id, section]) => document.getElementById(id) && !sections?.[section])) {
      const response = await fetch(base + 'cart?cfd_cart_refresh=' + Date.now(), { cache: 'no-store' });
      if (!response.ok) throw new Error(config.error);
      page = new DOMParser().parseFromString(await response.text(), 'text/html');
    }
    for (const [id, section, selector] of replacements) {
      const parsed = page || new DOMParser().parseFromString(sections?.[section] || '', 'text/html');
      const destination = document.getElementById(id);
      const source = parsed.getElementById(id) || (id === 'cart-icon-bubble' ? parsed.querySelector('.shopify-section') : null);
      if (!destination) continue;
      if (!source) throw new Error('Missing cart element: ' + id);
      if (selector) {
        const target = destination.querySelector(selector);
        const replacement = source.querySelector(selector);
        if (target && replacement) target.innerHTML = replacement.innerHTML;
      } else destination.innerHTML = source.innerHTML;
      if (id === 'main-cart-footer') {
        destination.dataset.timelineRequired = source.dataset.timelineRequired;
        destination.dataset.timelineSaved = source.dataset.timelineSaved;
        destination.className = source.className;
      }
    }
    document.querySelector('cart-items')?.classList.toggle('is-empty', cart.items.length === 0);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cart.items.length === 0);
    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart, cfdProtection: true });
    paint(cart);
  }
  async function reconcile(cart, toggle = false) {
    if (busy) { pending = true; return; }
    busy = true;
    failed = false;
    const errors = document.getElementById('cart-errors');
    if (errors) errors.textContent = '';
    paint(current);
    try {
      let state = cart || await request('cart.js');
      let sections;
      let changed = false;
      const selected = state.items.some(isProtection);
      if (toggle && selected) {
        const updates = Object.fromEntries(state.items.filter(isProtection).map(item => [item.key, 0]));
        state = await request('cart/update.js', { updates });
        sections = state.sections;
        changed = true;
      } else if (toggle && eligible(state)) {
        const added = await request('cart/add.js', { items: [{ id: config.variantId, quantity: 1 }] });
        sections = added.sections;
        state = await request('cart.js');
        changed = true;
      }
      const updates = protectionUpdates(state);
      if (Object.keys(updates).length) {
        state = await request('cart/update.js', { updates });
        sections = state.sections;
        changed = true;
      }
      current = state;
      if (changed) await render(state, sections);
      if (toggle) status(state.items.some(isProtection) ? config.added : config.removed);
    } catch (error) {
      console.warn('Shipment protection update:', error.message);
      failed = true;
      status(config.error);
    } finally {
      busy = false;
      paint(current);
      if (pending) { pending = false; reconcile(); }
    }
  }
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-cfd-protection-toggle]');
    if (toggle) {
      event.preventDefault();
      if (!busy) reconcile(null, true);
      return;
    }
    if ((busy || failed) && event.target.closest('[name="checkout"], a[href$="/checkout"], .cart__dynamic-checkout-buttons')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      status(busy ? config.working : config.error);
      if (failed && !busy) reconcile();
    }
  }, true);
  document.addEventListener('submit', event => {
    if ((busy || failed) && event.target.id === 'cart') {
      event.preventDefault();
      status(busy ? config.working : config.error);
    }
  }, true);
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
    if (event.cfdProtection) return;
    reconcile(event.cartData?.items ? event.cartData : null);
  });
  window.addEventListener('pageshow', event => { if (event.persisted) reconcile(); });
  if (current.items.length) reconcile();
})();
